import { ICAreaMetaApi } from "./icareameta.api";
import { Translation } from "../entities/translation";

import { IApi } from "../shared/iapi";
import { ICArea } from "../entities/icarea";

export class ICAreaApi extends ICArea implements IApi<ICArea> {
  AllChildrenIds: number[];
  AllFatherIds: number[];
  ChildrenIds: number[];
  FatherIds: number[];
  Level: number;
  MetaApis: ICAreaMetaApi[];
  Type: Translation[];
  TypeId: number;
  ClientId: number;
  AreaTree: string;

  constructor(data?: Partial<ICAreaApi>) {
    super(data);
    Object.assign(this, data);
  }

  get TypeTrad(): Translation {
    return this.Type[0];
  }

  public getParent(level: number): ICAreaApi {
    let client = new ICAreaApi(this);
    while (client && client.Level > level && client.Fathers.length > 0) {
      client = new ICAreaApi(client.Fathers[0].Father);
    }
    return client.Level == level ? client : null;
  }
}
